<template>
  <div class="repair-over-view" style="background: #f0f0f7">
    <div class="repair-over-view-line" style="margin: 0.15rem auto 0.15rem;">
      <div
        class="repair-person-count-box"
        style="background:linear-gradient(to right, rgba(52, 147, 235, .8), rgba(54, 212, 233, .8));"
      >
        <div class="repair-person-count-body">
          <div class="repair-person-count-box-info">
            <div class="repair-person-tip">当年报修次数</div>
            <div class="repair-person-count">
              {{ curYearCount }}<span>(次)</span>
            </div>
          </div>
          <img src="@/assets/over_view_icon/repair_y.png" />
        </div>
      </div>
      <div
        class="repair-person-count-box"
        style="background:linear-gradient(to right, rgba(240, 152, 25, .8), rgba(237, 222, 93, .8));;"
      >
        <div class="repair-person-count-body">
          <div class="repair-person-count-box-info">
            <div class="repair-person-tip">当月报修次数</div>
            <div class="repair-person-count">
              {{ curMonthCount }}<span>(次)</span>
            </div>
          </div>
          <img src="@/assets/over_view_icon/repair_m.png" />
        </div>
      </div>
      <div
        class="repair-person-count-box"
        style="background:linear-gradient(to right, rgba(255, 121, 121, .8), rgba(255, 167, 209, .8));"
      >
        <div class="repair-person-count-body">
          <div class="repair-person-count-box-info">
            <div class="repair-person-tip">当年报修收入</div>
            <div class="repair-person-count">
              {{ curYearMoney }}<span>(万)</span>
            </div>
          </div>
          <img src="@/assets/over_view_icon/money_y.png" />
        </div>
      </div>
      <div
        class="repair-person-count-box"
        style="background:linear-gradient(to right, rgba(51, 201, 96, .8), rgba(43, 205, 205, .8));"
      >
        <div class="repair-person-count-body">
          <div class="repair-person-count-box-info">
            <div class="repair-person-tip">当月报修收入</div>
            <div class="repair-person-count">
              {{ curMonthMoney }}<span>(万)</span>
            </div>
          </div>
          <img src="@/assets/over_view_icon/money_m.png" />
        </div>
      </div>
    </div>

    <div
      class="repair-over-view-line"
      style="margin: 0 0 0.13rem 0;padding: 0.12rem;position: relative;width: 100%;height: 378px;background: #FFFFFF;border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;"
    >
      <h2>报修统计</h2>
      <chart-time-select
        @getData="getRepairRecordStatictics"
        :positionRight="true"
      />
      <common-line
        style="z-index: 1000"
        lineId="repairRegisterRecordLine"
        :height="'332px'"
        :legendData="repairRegisterRecordLegendData"
        :xAxis="repairRegisterRecordXAxis"
        :yAxis="repairRegisterRecordYAxis"
        :series="repairRegisterRecordSeries"
      />
    </div>

    <div
      class="finance-over-view-line"
      style="margin: 0 0 20px 0;padding: 0.12rem;position: relative;width: 100%;
height: 378px;
background: #FFFFFF;
border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;"
    >
      <h2>缴费统计</h2>
      <chart-time-select
        @getData="getRepairConsumptionRecordStatictics"
        :positionRight="true"
      />
      <common-line
        style="z-index: 1000"
        lineId="repairConsumptionRecordLine"
        :height="'332px'"
        :legendData="repairConsumptionRecordLegendData"
        :xAxis="repairConsumptionRecordXAxis"
        :yAxis="repairConsumptionRecordYAxis"
        :series="repairConsumptionRecordSeries"
      />
    </div>
  </div>
</template>

<script>
import CommonLine from "../../../components/Echarts/Line/commonLine";
import { api } from "../../api/RepairManagement";
import { errorHandler } from "../../../utils/errorHandler";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/newChartTimeSelect";

export default {
  components: { ChartTimeSelect, CommonLine },
  name: "repair-over-view",
  data() {
    return {
      repairCount: 0,
      totalMoney: 0,
      curMonthCount: 0,
      curMonthMoney: 0,
      curYearCount: 0,
      curYearMoney: 0,

      repairRegisterRecordRadio: false,
      repairRegisterRecordTitle: "报修统计",
      repairRegisterRecordLegendData: [],
      repairRegisterRecordXAxis: {
        type: "category",
        name: "日期",
        data: [],
        nameTextStyle: {
          color: "#000",
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLabel: {
          color: "#000", // X 轴文字颜色
          fontSize: 'calc(100vw * 14/ 1920)',
        }
      },
      repairRegisterRecordYAxis: [
        {
          type: "value",
          name: "次数",
          nameTextStyle: {
            color: "#000",
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#aaa", // 外边框颜色
              type: "solid", // 外边框线型，可以设置为 'solid', 'dashed', 'dotted'
            }
          },
          axisLabel: {
            color: "#000", // X 轴文字颜色
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", // 设置为点线
              color: "#aaa" // 网格线颜色
            }
          },
          label: {
            show: true
          }
        }
      ],
      repairRegisterRecordSeries: [],

      repairConsumptionRecordRadio: false,
      repairConsumptionRecordTitle: "缴费统计",
      repairConsumptionRecordLegendData: [],
      repairConsumptionRecordXAxis: {
        type: "category",
        name: "日期",
        data: [],
        nameTextStyle: {
          color: "#000",
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLabel: {
          color: "#000", // X 轴文字颜色
          fontSize: 'calc(100vw * 14/ 1920)',
        }
      },
      repairConsumptionRecordYAxis: [
        {
          type: "value",
          name: "金额",
          nameTextStyle: {
            color: "#000"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#aaa", // 外边框颜色
              type: "solid" // 外边框线型，可以设置为 'solid', 'dashed', 'dotted'
            }
          },
          axisLabel: {
            color: "#000" // X 轴文字颜色
          },
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", // 设置为点线
              color: "#aaa" // 网格线颜色
            }
          },
          label: {
            show: true
          }
        }
      ],
      repairConsumptionRecordSeries: []
    };
  },
  mounted() {
    this.getRepairOverview();
    // this.getRepairRecordStatictics()
    // this.getRepairConsumptionRecordStatictics(1)
  },
  methods: {
    getRepairOverview() {
      this.$axios
        .get(api.getRepairOverview, {})
        .then(res => {
          let data = res.data.data;
          this.curYearMoney = data.curYearMoney;

          this.curYearCount = data.curYearCount;
          this.curMonthMoney = data.curMonthMoney;
          this.curMonthCount = data.curMonthCount;
        })
        .catch(errorHandler("获取数据失败"));
    },
    getRepairRecordStatictics(type, startTime, endTime) {
      this.$axios
        .post(`${api.getRepairRecordStatictics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let seriesData = [];
          data.map(v => {
            seriesData.push(v.count);
            if (type === 1) {
              let dateArr = v.date.split("-");
              let showData = `${dateArr[1]}-${dateArr[2]}`;
              xData.push(showData);
            } else {
              xData.push(v.date);
            }
          });
          this.repairRegisterRecordXAxis.data = xData;
          this.repairRegisterRecordSeries = [
            {
              name: "",
              type: "line",
              stack: "统计",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#0A84FF"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(10,132,255,0.4)"
                    },
                    {
                      offset: 1,
                      color: "rgba(10,132,255,0)"
                    }
                  ]
                }
              },
              data: seriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    },

    getRepairConsumptionRecordStatictics(type, startTime, endTime) {
      this.$axios
        .post(`${api.getRepairConsumptionRecordStatictics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let seriesData = [];
          data.map(v => {
            seriesData.push(v.money.toString());
            if (type === 1) {
              let dateArr = v.date.split("-");
              let showData = `${dateArr[1]}-${dateArr[2]}`;
              xData.push(showData);
            } else {
              xData.push(v.date);
            }
          });
          this.repairConsumptionRecordXAxis.data = xData;

          this.repairConsumptionRecordSeries = [
            {
              name: "",
              type: "line",
              stack: "统计",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#0DC020"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(27,182,16,0.4)" }, // 渐变的起始颜色
                  { offset: 1, color: "rgba(35,181,22,0)" } // 渐变的结束颜色
                ])
              },

              data: seriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    }
  },

  watch: {}
};
</script>

<style lang="less" scoped>
.repair-over-view {
  padding: 0 2% 10px;
  margin: 0;
  h2 {
    position: absolute;
    top: 6.2%;
    font-size: 0.1rem;
    text-align: left;
    z-index: 1001;
  }
  .repair-over-view-line {
    display: flex;
    justify-content: space-between;

    .repair-person-count-box {
      width: 1.9375rem !important;
      height: 0.82rem !important;
      padding: 0.17rem;
      border-radius: 10px;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;

      i {
        width: 30%;
        font-size: 48px;
      }

      .repair-person-count-body {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 0.4rem;

        img {
          height: 0.4rem;
          width: 0.39rem;
        }

        span {
          font-size: 0.08rem;
        }
      }

      .repair-person-count-box-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 70%;
        text-align: left;

        .repair-person-count {
          font-size: 32px;
          word-wrap: break-word;
        }

        .repair-person-tip {
          font-size: 0.1rem;
        }
      }
    }

    .repair-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }

    .repair-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      overflow: hidden;
    }

    .el-table {
      thead {
        th {
          padding: 6px 0;
          text-align: center;
          color: #666666;
          background-color: #eff1f5;
        }
      }

      tbody {
        td {
          padding: 6px 0;
          text-align: center;
          color: #ff0000;
        }
      }
    }

    .el-pagination {
      padding: 0;
    }
  }
}
.chart-time-select1{
  top: 0.13rem !important;
}
</style>



// WEBPACK FOOTER //
// src/view/RepairManagement/repairOverView/repairOverView.vue